<template>
  <main class="loan-introduce home ">
    <headNav id="nav-bar" :bannerType="1" ref="header"> </headNav>
    <div class="banner">
      <h3 class="banner-title">要想上车快 就用采购宝</h3>
      <p class="small-info">针对汽车采购需求提供的专项融资</p>
      <p>
        无需抵押，融资申请简单，放款速度快，年化费率15.6%，按日计息，能够极大的提高合作伙伴<br />的资金利用效率。
      </p>
    </div>
    <section class="content-wrapper">
      <div class="product-wrapper">
        <h4 class="content-title"><span>产品优势</span></h4>
        <ul class="product">
          <li v-for="(intro, index) of introduce" :key="index">
            <p class="icon--wrapper">
              <img class="pro-img" :src="intro.img" alt="" />
            </p>
            <el-row class="name">{{ intro.title }}</el-row>
            <el-row class="des">{{ intro.des }}</el-row>
          </li>
        </ul>
        <!-- <customerService /> -->
      </div>
      <div class="detail-wrapper">
        <div class="detail">
          <p class="detail-name">
            <span
              class="detail-one"
              :class="{ active: index === 1 }"
              @mouseover="index = 1"
              >01 计息举例</span
            >
            <span
              class="detail-one"
              :class="{ active: index === 2 }"
              @mouseover="index = 2"
              >02 业务合作商</span
            >
          </p>
          <div class="process-des" v-if="index === 1">
            <h3>A公司采购10台单价10万元车辆（总价100万元）</h3>
            <ul>
              <li class="process-title">流程如下:</li>
              <li>①完成注册获得额度；</li>
              <li>②申请借款80万元，缴纳保证金=80万*5%=4万；</li>
              <li>③合作商客户经理上门指导，通过车价评估；</li>
              <li>④签订合同，放款-提现-购车</li>
            </ul>
            <ul class="interest-rate">
              <h3>放款当日开始计息，利息不满10日，按10日计算</h3>
              <li>A公司用款5天，利息=10*80万*0.043%=3440元；</li>
              <li>A公司用款15天，利息=15*80万*0.043%=5160元</li>
            </ul>
          </div>
          <div class="process-des" v-if="index === 2">
            <h3>第一车贷</h3>
            <ul>
              <!-- <li class="process-title">流程如下:</li> -->
              <li>
                第1车贷是中国第一家在新车及二手车领域同时为B端和C端用户提供金融及交易服务的汽车互联网平台。引领中国汽车科技金融的发展，为汽车后市场产业链上的经营者与消费者提供专业可靠、高效便捷的一站式综合解决方案，共建有生命力的汽车产业链生态圈作为独立第三方汽车供应链金融平台。覆盖全国30个省，160余个城市，累计放款规模突破300亿元，作为独立第三方汽车供应链金融平台，业务规模全国第一。
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="operation-wrapper">
        <h4 class="content-title"><span>操作流程</span></h4>
        <div class="operation-content">
          <ul class="tab-top">
            <li
              class="list"
              :class="{ active: activeIndex === 1 }"
              @mouseover="activeIndex = 1"
            >
              授信
            </li>
            <li
              class="list"
              :class="{ active: activeIndex === 2 }"
              @mouseover="activeIndex = 2"
            >
              借钱
            </li>
            <li
              class="list"
              :class="{ active: activeIndex === 3 }"
              @mouseover="activeIndex = 3"
            >
              还钱
            </li>
          </ul>
          <section class="tab-content">
            <div class="tab1" v-if="activeIndex === 1">
              <ul>
                <li>
                  <img src="../assets/images/orange-loan/step-01.png" alt="" />
                  <span>补全<br />认证信息</span> <b class="line"></b>
                </li>
                <li>
                  <img src="../assets/images/orange-loan/step-02.png" alt="" />
                  <span>线下<br />提供资料</span> <b class="line"></b>
                </li>
                <li>
                  <img src="../assets/images/orange-loan/step-03.png" alt="" />
                  <span>获得<br />授信额度</span>
                </li>
              </ul>
            </div>
            <div class="tab2" v-if="activeIndex === 2">
              <ul>
                <li class="bond-info">
                  <img src="../assets/images/orange-loan/step-01.png" alt="" />
                  <span
                    >发起申请<br /><b class="bond">缴纳保证金给合作方</b>
                    <el-tooltip placement="bottom-start">
                      <div slot="content" class="loan-introduce-tip-info">
                        借款前需缴纳保证金;<br />
                        保证金的缴纳金额为实际借款额的5% <br />
                        <br />
                        <span
                          style="color: white; opacity: 0.8; margin-top:10px"
                          >如申请80万元，需缴纳保证金=80万*5%=4万</span
                        >
                        <br />
                      </div>
                      <img
                        class="alert-icon"
                        src="../assets/images/orange-loan/alert-info.svg"
                        alt=""
                      />
                    </el-tooltip>
                  </span>
                  <b class="line"></b>
                </li>
                <li>
                  <img src="../assets/images/orange-loan/step-02.png" alt="" />
                  <span>线下<br />评估审核</span> <b class="line"></b>
                </li>
                <li>
                  <img src="../assets/images/orange-loan/step-03.png" alt="" />
                  <span>签署<br />借款合同</span> <b class="line"></b>
                </li>
                <li>
                  <img src="../assets/images/orange-loan/step-04.png" alt="" />
                  <span><br />放款到账</span>
                </li>
              </ul>
            </div>
            <div class="tab3" v-if="activeIndex === 3">
              <ul>
                <li>
                  <img src="../assets/images/orange-loan/step-01.png" alt="" />
                  <span>账户预存</span> <b class="line"></b>
                </li>
                <li>
                  <img src="../assets/images/orange-loan/step-02.png" alt="" />
                  <span>系统扣款</span> <b class="line"></b>
                </li>
                <li>
                  <img src="../assets/images/orange-loan/step-03.png" alt="" />
                  <span>已还清</span>
                </li>
              </ul>
              <p class="alert-info">
                *每月20日系统自动扣息1次，请提前预存（如5日放款，需预存15天利息；如15日放款，需预存5天利息)
              </p>
              <p class="alert-info">
                *未能及时还款便视为逾期。逾期用户的相关信息将被写入人行征信系统
              </p>
            </div>
          </section>
        </div>
      </div>
      <div class="question-wrapper">
        <h4 class="content-title"><span>常见问题与解答</span></h4>
        <ul class="question-list">
          <li class="list" v-for="(item, index) in questions" :key="index">
            <p class="list-name">{{ item.title }}</p>
            <p
              class="list-content"
              v-for="(des, index) in item.content"
              :key="index"
              :class="{
                'danger-color': des.des == '车辆价格完成评估后，无法终止。',
              }"
            >
              {{ des.des }}
            </p>
          </li>
        </ul>
      </div>
      <div class="bottom-banner">
        <h2 class="bottom-title">尊享采购宝 100万轻松借</h2>
        <p class="apply-btn" @click="toLoan()">马上申请</p>
        <!--跳转页面-->
      </div>
    </section>
    <foot></foot>
  </main>
</template>

<script>
import headNav from './header.vue'
import foot from './footer.vue'
import { mapState } from 'vuex'
import cookie from '../cookie/cookie'
// import customerService from '../components/console-common/customer-service.vue'
export default {
  components: {
    headNav,
    foot,
    // customerService,
  },
  created() {
    this.getUserName()
  },
  data() {
    return {
      activeIndex: 1,
      index: 1,
      showLogin: false,
      usernameZh: '',
      type: 'login',
      introduce: [
        {
          img: require('../assets/images/orange-loan/percent-icon.svg'),
          title: '日费率0.433‰',
          des: '按日计息 随借随还',
        },
        {
          img: require('../assets/images/orange-loan/proportion-icon.svg'),
          title: '融资比例高',
          des: '最高融资车价80%',
        },
        {
          img: require('../assets/images/orange-loan/copywriting-icon.svg'),
          title: '步骤很简单',
          des: '3步即可完成',
        },
        {
          img: require('../assets/images/orange-loan/speed-icon.svg'),
          title: '放款极速',
          des: '当日申请 T+2日内放款',
        },
      ],
      questions: [
        {
          title: '1.如何提高授信额度',
          content: [
            {
              des:
                '无不良还款，申请提高授信额度，根据银行流水、司机数量、自有资产、运营车辆评估，数量及金额越多授信额越大。',
            },
          ],
        },
        {
          title: '2.如何终止进行中的借款流程',
          content: [
            {
              des:
                '在车辆价格评估前，可随时终止：在借款各节点过程中，点击“取消借款”，按“确认”即可',
            },
            {
              des: '车辆价格完成评估后，无法终止。',
            },
          ],
        },
        {
          title: '3.提前还款时，账户资金不足，如何计息？',
          content: [
            {
              des:
                '点击“提前还款”，系统自动扣款，如当天未全部还清，则按全部借款额计息；如：借款80万，当天扣款78万，当日产生费用=80万*0.043%=344元',
            },
          ],
        },
        {
          title: '4.还款日未还款，产生逾期，是否产生罚息、扣押？',
          content: [
            {
              des:
                '按借款合同中规定，还款日未还款，罚息=逾期金额*综合费率*1.5/360*逾期天数；',
            },
            {
              des:
                '举例：商户A逾期金额是50万，年化综合费率15.6%，逾期10天，则欠款到期后的罚息金额=50万*15.6%*（1.5/360）*10=3250元，合作商客户经理线下',
            },
            {
              des: '会有还款提醒，并评估风险。',
            },
          ],
        },
        {
          title: '5.何种情况下，会触发强制终止合约？',
          content: [
            {
              des:
                '①资产出现高风险，未足额还款时，将车辆质押等行为；②拒绝配合贷后盘库工作，私自将车辆转移。',
            },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapState('info', {
      btnClickOne: 'btnClickOne',
    }),
  },
  methods: {
    getUserName() {
      this.usernameZh = cookie.getCookie('usernameZh')
    },
    toLoan() {
      if (this.usernameZh) {
        this.$router.push({
          path: '/console/orange-loan/loan-home',
        })
      } else {
        this.$refs.header.checkLogin()
      }
      // this.$refs.header.checkLogin()
    },
  },
}
</script>

<style lang="stylus">
@import '../assets/css/common-color.styl'
.el-tooltip__popper
    padding 20px
.customer-phone
  display block
  margin-top 15px
.customer-phone:hover
  font-weight 600
  cursor pointer
.loan-introduce-tip-info
  color white
  font-size 12px
  padding 5px
.loan-introduce
  background white
  position relative
  a
    text-decoration none
  .el-tooltip__popper.is-dark
    display flex
    flex-direction column
    justify-content center
    align-items center
    padding 16px
    .phone
      opacity 0.97
      font-family DINPro-Medium
      font-size 20px
      color #FFFFFF
      text-align left
      line-height 14px
      span
        display block
        margin-bottom 16px
        opacity 0.6
        font-size 12px
  .home
    .header
      position relative
      .nav
        a
          color gray03
        a.active
          color gray03
        a:nth-child(1)
          color gray01
        a:hover
          color gray01
      .login
        p
          color gray03
        p:hover
          color gray01
        .user-txt
          color gray03
          &:hover
            color gray01
            cursor pointer
        span
          color gray03
  .banner
    background url('../assets/images/orange-loan/banner.png') no-repeat center
    background-size 100%
    padding 50px 0 98px 400px
    box-sizing border-box
    height 336px
    .banner-title
      font-family STSongti-SC-Black
      font-size 40px
      color gray02
      line-height 40px
      margin-bottom 32px
      padding-top 25px
    p
      color gray02
    .small-info
      opacity 0.8
      font-size 16px
      color gray03
      margin-bottom 35px
      letter-spacing 11px
      padding 10px 0
      border-top 1px solid rgba(133,139,156, 0.1)
      border-bottom 1px solid rgba(133,139,156, 0.1)
      width 440px
  .content-wrapper
    width 100%
    .content-title
      font-size 25.6px
      color gray01
      text-align center
      padding-top 116px
      box-sizing border-box
      span
        display block
        height 52px
        background url('../assets/images/orange-loan/features.png') no-repeat center top
        line-height 52px
        width 282px
    .product-wrapper
      background white
      display flex
      justify-content center
      align-items center
      flex-direction column
      .product
        display flex
        justify-content space-between
        align-items center
        width 764px
        box-sizing border-box
        margin 80px 0 100px 0
        padding-left 0
        li
          display flex
          flex-direction column
          align-items center
          .icon--wrapper
            background #FFFFFF
            box-shadow 4px 8px 20px 10px rgba(220,223,230,0.20)
            display flex
            justify-content center
            align-items center
            height 120px
            width 120px
            border-radius 50%
            margin-bottom 40px
          .name
            font-family PingFangSC-Medium
            font-size 18px
            color gray02
            text-align center
            line-height 18px
            margin-bottom 10px
          .des
            font-family PingFangSC-Light
            font-size 16px
            color gray04
            text-align center
            line-height 14px
    .detail-wrapper
      height 472px
      background url('../assets/images/orange-loan/bg.png') no-repeat center center
      background-size 100%
      .detail
        padding 60px 0
        display flex
        justify-content center
        box-sizing border-box
        .detail-name
          font-size 18px
          color gray03
          text-align right
          line-height 18px
          span
            display block
            padding-left 20px
            text-align left
          .detail-one
            width 158px
            height 48px
            line-height 48px
            color gray03
            ansform rotate(90deg)
            margin-bottom 30px
          .active
            color white
            background-image linear-gradient(42deg, #2276FB 0%, #37A7FF 100%)
            box-shadow 0 8px 16px 0 rgba(47,134,246,0.20)
        .process-des
          float left
          padding 20px 32px
          box-sizing border-box
          color gray01
          height 352px
          background #fff
          // background white url('../assets/images/orange-loan/process-logo.png') no-repeat 20px 16px
          h3
            font-size 20px
            margin-bottom 20px
          ul
            padding-left 0px
            .process-title
              font-size 16px
            li
              // margin-bottom 5px
              line-height 30px
              width 482px
              font-size 14px
          .interest-rate
            margin-top 30px
            font-size 14px
            h3
             color primary-color
             margin-bottom 5px
             font-size 14px
             font-style normal
            // li
            //   margin-bottom 5px
    .operation-wrapper
      background #FFFFFF
      padding 100px 265px
      display flex
      flex-direction column
      justify-content center
      align-items center
      box-sizing border-box
      .content-title
        padding 0 0 60px 0
        box-sizing border-box
        span
          background url('../assets/images/orange-loan/progress.png') no-repeat center top
      .operation-content
        border 0 solid #F0F0F0
        height 315px
        box-shadow 0 2px 16px 8px rgba(240,240,240,0.40)
        .tab-top
          display flex
          justify-content space-around
          align-items center
          margin-bottom 58px
          padding-left 0
          .list
            height 96px
            padding-top 53px
            font-family PingFangSC-Medium
            font-size 22px
            color gray02
            line-height 18px
            width 303px
            box-sizing border-box
            text-align center
            &:hover
              cursor pointer
          li:nth-child(1)
            background url('../assets/images/orange-loan/01.png') no-repeat center 26px
          li:nth-child(2)
            background url('../assets/images/orange-loan/02.png') no-repeat center 26px
          li:nth-child(3)
            background url('../assets/images/orange-loan/03.png') no-repeat center 26px
          li:nth-child(1).active
            background  url('../assets/images/orange-loan/01.png') no-repeat center 26px, linear-gradient(42deg, #2276FB 0%, #37A7FF 100%)
            box-shadow 0 8px 16px 0 rgba(47,134,246,0.20)
            color white
          li:nth-child(2).active
            background  url('../assets/images/orange-loan/02.png') no-repeat center 26px, linear-gradient(42deg, #2276FB 0%, #37A7FF 100%)
            box-shadow 0 8px 16px 0 rgba(47,134,246,0.20)
            color white
          li:nth-child(3).active
            background  url('../assets/images/orange-loan/03.png') no-repeat center 26px, linear-gradient(42deg, #2276FB 0%, #37A7FF 100%)
            box-shadow 0 8px 16px 0 rgba(47,134,246,0.20)
            color white
      .tab-content
        padding 0 160px 44px 160px
        box-sizing border-box
        .tab1
          .line
            width 220px
            top 22%
            left 94%
        ul
          display flex
          justify-content space-between
          align-items center
          margin-bottom 24px
          padding-left 0
          li
            display flex
            flex-direction column
            text-align center
            align-items center
            position relative
            span
             font-size 14px
             color gray02
            .line
              height 1px
              background #DCDFE6
              position absolute
            img
              width 48px
        .tab2
          .bond-info
            margin-right -15px
            .line
              width 140px
              left 67%
          .line
            width 120px
            left 86%
            top 22%
          .bond
            font-size 12px
            color gray04
          .alert-icon
            position relative
            top 2px
            left 1px
            width 14px
          ul
            width 100%
        .tab3
          .line
            width 225px
            top 27%
            left 87%
          .alert-info
            font-size 12px
            color gray04
            margin-bottom 10px
    .question-wrapper
      display flex
      justify-content center
      flex-direction column
      align-items center
      padding-bottom 60px
      background gray07
      .content-title
        span
          background url('../assets/images/orange-loan/question.png') no-repeat center top
      .question-list
        margin-top 60px
        .list
          margin-bottom 32px
          .list-name
            font-size 18px
            color gray01
            line-height 18px
          .list-content
            font-size 14px
            color gray02
            line-height 14px
            margin-top 15px
          .danger-color
            color: #FC9153
    .bottom-banner
      display flex
      flex-direction column
      align-items center
      justify-content center
      background url('../assets/images/orange-loan/bottom-banner.png') no-repeat center center
      background-size 100% 100%
      .bottom-title
        font-size 40px
        color white
        padding-top 58px
      .apply-btn
        width 120px
        height 44px
        border 1px solid white
        color white
        margin-top 24px
        text-align center
        line-height 44px
        cursor pointer
        margin-bottom 58px
        &:hover
          color primary-color
          background rgba(255,255,255,0.2)
</style>
